export default __webpack_public_path__ + "static/special-surfaces-19b3c55122eaaeb7c66853c8391b6992.png";